import {faQuestionCircle} from "@fortawesome/pro-solid-svg-icons";
import {faCarrot} from "@fortawesome/pro-solid-svg-icons/faCarrot";
import {faMessages} from "@fortawesome/pro-solid-svg-icons/faMessages";
import {faPhone} from "@fortawesome/pro-solid-svg-icons/faPhone";
import {faSignalBars} from "@fortawesome/pro-solid-svg-icons/faSignalBars";
import {faSparkles} from "@fortawesome/pro-solid-svg-icons/faSparkles";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {DropdownMenu, ItemMenuEntry, ToggleSwitch, ToggleType, useLayout} from "@twigsby/frontend-framework";
import React from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {useNavigate} from "react-router-dom";
import {useSite} from "../Providers/SiteInterfaceProvider";

type UserHelpMenuType = {

}

const UserHelpMenu = (props: UserHelpMenuType) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { setOnboarding, onboardingActive, setUpdatesModal, UpdateSiteContact } = useSite();
    const { sidebarOpen,isMedium, isUltraWide } = useLayout();

    return (
        <DropdownMenu
            trigger={
                <div className={'side-navigation-entry collapsable'} tabIndex={0}>
                    <FontAwesomeIcon icon={faQuestionCircle} fixedWidth={true}/>
                    {(sidebarOpen || !isMedium || isUltraWide) && (
                        <div className="navigation-label">{t('help.title')}</div>
                    )}
                </div>
            }
        >
            <ItemMenuEntry title={t("help.actions.enableOnboarding")} onClick={() => setOnboarding(!onboardingActive)}
                           addonContent={
                               <ToggleSwitch type={ToggleType.Switch} hideLabel
                                             label={t("help.actions.enableOnboarding")} name="enableOnboarding"
                                             defaultChecked={onboardingActive}/>
                           }/>

            <ItemMenuEntry title={t('labels.divider')} sectionDivider={true}/>

            <ItemMenuEntry title={t('help.actions.whatsNew')} onClick={() => setUpdatesModal(true)} icon={faSparkles}/>
            <ItemMenuEntry title={t('help.actions.status')} onClick={() => navigate('/status')} icon={faSignalBars}/>

            <ItemMenuEntry title={t('labels.divider')} sectionDivider={true}/>

            <ItemMenuEntry title={t('help.actions.helpCentre')} onClick={() => navigate('/help-centre')}
                           icon={faQuestionCircle}/>

            <ItemMenuEntry title={t('labels.divider')} sectionDivider={true}/>

            <ItemMenuEntry title={t('getInTouch.actions.message')} onClick={() => UpdateSiteContact(true)}
                           icon={faMessages}/>

            <a href={'https://www.ukpostbox.com/contact/callback-request'} className={'item-menu-entry'}
               target={'_blank'} rel={"nofollow noopener noreferrer"}>
                <FontAwesomeIcon icon={faPhone} fixedWidth={true} />
                <span>{t('getInTouch.actions.call')}</span>
            </a>

        </DropdownMenu>
    )
}
export {UserHelpMenu}
